import { useQuery } from "@tanstack/react-query";
import { getOrgStructureItem } from "../../api/apiOrgStructureItems";
import i18next from "i18next";

export function useGetOrgStructureItem(id) {
    const { isLoading, data: orgStructureItem, error } = useQuery({
        queryKey: ["orgStructureItems", id, i18next.language],
        queryFn: () => getOrgStructureItem(id),
        enabled: !!id,
        retry: false,
    });
    return { isLoading, error, orgStructureItem };
}
